/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostPressReleaseDocumentFileSuccessResponseData,
    PostPressReleaseDocumentFileSuccessResponseDataFromJSON,
    PostPressReleaseDocumentFileSuccessResponseDataFromJSONTyped,
    PostPressReleaseDocumentFileSuccessResponseDataToJSON,
} from './PostPressReleaseDocumentFileSuccessResponseData';

/**
 * POST /press_release/{release_id}/pdf_file
 * @export
 * @interface PostPressReleaseDocumentFileResponse
 */
export interface PostPressReleaseDocumentFileResponse {
    /**
     * 
     * @type {number}
     * @memberof PostPressReleaseDocumentFileResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof PostPressReleaseDocumentFileResponse
     */
    message: string;
    /**
     * 
     * @type {PostPressReleaseDocumentFileSuccessResponseData}
     * @memberof PostPressReleaseDocumentFileResponse
     */
    data: PostPressReleaseDocumentFileSuccessResponseData;
}

export function PostPressReleaseDocumentFileResponseFromJSON(json: any): PostPressReleaseDocumentFileResponse {
    return PostPressReleaseDocumentFileResponseFromJSONTyped(json, false);
}

export function PostPressReleaseDocumentFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseDocumentFileResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PostPressReleaseDocumentFileSuccessResponseDataFromJSON(json['data']),
    };
}

export function PostPressReleaseDocumentFileResponseToJSON(value?: PostPressReleaseDocumentFileResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PostPressReleaseDocumentFileSuccessResponseDataToJSON(value.data),
    };
}

